import { BabyNotificationType } from 'types'
import { BottleSmileIcon, SleepSmileIcon } from 'components'

export const isFoodNotification = (notificationType: BabyNotificationType) =>
  notificationType === BabyNotificationType.FOOD

export const isSleepNotification = (notificationType: BabyNotificationType) =>
  notificationType === BabyNotificationType.SLEEP

export const getNotificationName = (notificationType: BabyNotificationType) =>
  isFoodNotification(notificationType) ? 'Кормление' : 'Сон'

export const getNotificationIcon = (notificationType: BabyNotificationType) =>
  isFoodNotification(notificationType) ? (
    <BottleSmileIcon width={24} height={24} />
  ) : (
    <SleepSmileIcon width={24} height={24} />
  )
